import BaseService from "./geral/BaseService";

const base = "OrcamentoWebCalcExport";

export default class OrcamentoExportService extends BaseService {
  constructor() {
    super(base);
  }

  Detalhes(orcamentoId) {
    return super.httpGet(`${base}/Detalhe?orcamentoId=${orcamentoId}`);
    
    }

ListarTipos() {
    return super.httpGet(`${base}/ListarTipos`);
    
    }

Pesquisar(codTipo, valorTipo) {
  // let listaRetorno = []
  // for (let i = 0; i < 3; i++) {
  //   listaRetorno.push(
  //     {
  //       Id: i,
  //       Os:"123456789",
  //       Servico:"Este é um serviço teste",
  //       Cntr:"THIA123456",
  //       Saida:"2017-08-22T13:58:29",
  //       Unitario:250.01,
  //       Qtd: 1.0,
  //       Total: 250.00,
  //       Faturado: 250.00,
  //       Faturar: 250.00,
  //       Situacao: "Disponível",
  //       Despachante:"PESSOA IMPORTANTE",
  //       Cliente: "PESSOA MENOS IMPORTANTE"
  //     }
  //   )
  // }
  // return Promise.resolve({data:listaRetorno})  
  
  return super.httpGet(`${base}/Processar?codigoTipo=${codTipo}&valorTipo=${valorTipo}`);
    
  }

  IncluirCliente (cliente) {
    return Promise.resolve({
      Sucesso: true,
      Mensagem:"Carinha inserido com sucesso"
    })
  }

  GerarBoleto(codTipo, valorTipo, refCliente, send) {
    return super.httpPost(`${base}/GerarBoleto?codigoTipo=${codTipo}&valorTipo=${valorTipo}&refCliente=${refCliente}`, send)
  }

}



// WEBPACK FOOTER //
// ./src/services/OrcamentoExportService.js